import { ImagePicture } from 'approot/shared/images/images';

import womanWithQuestionMarkAvif from './content-woman-with-question-mark.avif';
import womanWithQuestionMarkWebp from './content-woman-with-question-mark.webp';
import womanWithQuestionMarkPng from './content-woman-with-question-mark.png';

const ImageContentWomanWithQuestionMark = ({
  width,
  lazyLoad = true,
}: {
  width: number;
  lazyLoad?: boolean;
}) => (
  <ImagePicture
    lazyLoad={lazyLoad}
    avif={{ path: womanWithQuestionMarkAvif }}
    webp={{ path: womanWithQuestionMarkWebp }}
    png={{ path: womanWithQuestionMarkPng }}
    style={width ? { width } : undefined}
  />
);

export default ImageContentWomanWithQuestionMark;
